import { render, staticRenderFns } from "./GrowthList.vue?vue&type=template&id=72089282&scoped=true"
import script from "./GrowthList.vue?vue&type=script&lang=js"
export * from "./GrowthList.vue?vue&type=script&lang=js"
import style0 from "./GrowthList.vue?vue&type=style&index=0&id=72089282&prod&scoped=true&lang=css"
import style1 from "./GrowthList.vue?vue&type=style&index=1&id=72089282&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72089282",
  null
  
)

export default component.exports